import React, { useState } from 'react'
import class_full
	from "../model/full";
import class_short
	from "../model/short";
import class_euro
	from "../model/euro";
import class_math
	from "../model/math";
import class_music
	from "../model/music"
import class_rules
	from "../model/rules";
import i18n from '../i18n/i18n';

export const DataContext = React.createContext({});

export const DataProvider = (props) => {

	const initialState = {
		full: new class_full(),
		short: new class_short(),
		euro: new class_euro(),
		music: new class_music(),
		math: new class_math(),
		rules: new class_rules()
	}

	const [state, setState] = useState(initialState)

	const reload = () => {
	}

	return (
		<DataContext.Provider
			value={{state}}
		>
			{props.children}
		</DataContext.Provider>
	);
}